import type { PatientCoverage } from '@features/patient-coverages/types';

export function eligibilityCoverageLabel(coverage: PatientCoverage): string {
  const order =
    coverage.coverage_order === 1
      ? 'Primary'
      : coverage.coverage_order === 2
        ? 'Secondary'
        : `Coverage ${coverage.coverage_order}`;
  const member = coverage.member_id?.replace(/\s/g, '').slice(-4);
  return [
    coverage.payer_name || coverage.plan_name || 'Insurance plan',
    order,
    coverage.display_status || coverage.status,
    member ? `ending ${member}` : null,
  ]
    .filter(Boolean)
    .join(' · ');
}
